<template>
  <div class="pa-4">
    <RichText
      v-model="store.plan.purpose"
      label="1.1 Purpose"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.executive_summary"
      label="1.2 Executive Summary"
      class="mb-4"
      required
      :readonly="readonly"
    />
  </div>
</template>

<script setup lang="ts">
import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";

const props = defineProps<{
  readonly: boolean;
}>();

const store = useAMPStore();
</script>
